import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Toast from "../Toast/Toast";
import { removeToast } from "../../../redux/slices/toastSlice";

import "./ToastContainer.scss";

const AUTO_DISMISS = 1500;

const ToastContainer = () => {
  const toasts = useSelector((state) => state.toasts);
  const dispatch = useDispatch();

  useEffect(() => {
    // Auto-dismiss logic for each toast
    if (!toasts.length) return;
    const timers = toasts.map((toast) =>
      setTimeout(() => {
        dispatch(removeToast(toast.id));
      }, AUTO_DISMISS)
    );
    return () => timers.forEach(clearTimeout);
  }, [toasts, dispatch]);

  return (
    <div className="toast-container">
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          {...toast}
          onClose={() => dispatch(removeToast(toast.id))}
        />
      ))}
    </div>
  );
};

export default ToastContainer;
